module.exports = "/next-static/_next/static/images/block_image_guest_interviews-9ea4784de3ea7d64a42a1c5f61960dbb.png";